import { useRef, useState, useCallback } from "react";
import "@/App.css";
import "lenis/dist/lenis.css";
import { ReactLenis, useLenis } from "lenis/react";
import { MotionConfig } from "framer-motion";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { WhyUs } from "./components/WhyUs";
import { Services } from "./components/Services";
import { Gallery } from "./components/Gallery";
import { Reviews } from "./components/Reviews";
import { FAQ } from "./components/FAQ";
import { BookingForm } from "./components/BookingForm";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingActions } from "./components/FloatingActions";

const Site = () => {
  const lenis = useLenis();
  const [selectedService, setSelectedService] = useState("");

  const scrollToId = useCallback(
    (id) => {
      const el = document.getElementById(id);
      if (!el) return;
      if (lenis) {
        lenis.scrollTo(el, { offset: id === "home" ? 0 : -72, duration: 1.4 });
      } else {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    [lenis]
  );

  const handleBook = useCallback(
    (serviceName = "") => {
      if (serviceName) setSelectedService(serviceName);
      scrollToId("book");
    },
    [scrollToId]
  );

  return (
    <div className="App">
      <Navbar onNavigate={scrollToId} onBook={() => handleBook()} />
      <main>
        <Hero onBook={() => handleBook()} />
        <WhyUs />
        <Services onBook={handleBook} />
        <Reviews />
        <Gallery />
        <FAQ />
        <BookingForm selectedService={selectedService} />
        <Contact />
      </main>
      <Footer onNavigate={scrollToId} />
      <FloatingActions onBook={() => handleBook()} />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <Site />
      </ReactLenis>
    </MotionConfig>
  );
}

export default App;
